import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class ATCcodeEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("ATC Code", ListDataColumn.TEXT, "atccode"),
                new ListColumn("ATC Code Description", ListDataColumn.TEXT, "atccode_Desc"),
                new ListColumn("Type", ListDataColumn.LOOKUP, "type_Term", "type_Term"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
                new ListColumn("Deprecated", ListDataColumn.LOOKUP, "deprecated", "yesNo"),
            ];

            const itemFinderTreeColumns=[
                new ListColumn("ATC Code", ListDataColumn.TEXT, "atccode"),
                new ListColumn("ATC Code Description", ListDataColumn.TEXT, "atccode_Desc"),
                new ListColumn("Type", ListDataColumn.LOOKUP, "type_Term", "type_Term"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
                new ListColumn("Deprecated", ListDataColumn.LOOKUP, "deprecated", "yesNo"),
            ];

            super(items, itemFinderArrayColumns, itemFinderTreeColumns);


    }

}